import React, { useEffect, useState } from 'react';

/**
 * Master row chevron. Toggles AG Grid master/detail expansion.
 * Hidden (but space-preserving) on non-master rows so columns line up.
 */
function ExpandChevronCell(params) {
  const { node } = params;
  const [expanded, setExpanded] = useState(Boolean(node?.expanded));

  useEffect(() => {
    if (!node) return undefined;
    const onExpanded = () => setExpanded(Boolean(node.expanded));
    node.addEventListener('expandedChanged', onExpanded);
    return () => node.removeEventListener('expandedChanged', onExpanded);
  }, [node]);

  if (!node?.master) {
    return <span className="cag-chevron cag-chevron--hidden" aria-hidden="true" />;
  }

  return (
    <button
      type="button"
      className={`cag-chevron${expanded ? ' cag-chevron--expanded' : ''}`}
      onClick={() => node.setExpanded(!node.expanded)}
      aria-label={expanded ? 'Collapse row' : 'Expand row'}
    >
      <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
        <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
    </button>
  );
}

export default ExpandChevronCell;
